mutation ProvisionPhoneNumber($input: PhoneNumberProvisionInput!) {
    phoneNumberProvision(input: $input) {
        inboxChannel {
            id
            phone {
                id
                numberFormatted
            }
        }
    }
}
